import { GAME_BY_ID, GAME_NAME, GAME_REQUEST } from '../mutations_type.js'
import { GAMES_API, GAME_ID_API } from '../../services/api/api.js'

import axios from 'axios'
import router from '@/router'

const state = {
  games: [],
  gameById: [],
  gameName: [],
}

const getters = {
  GAMES: state => {
    return state.games
  },
  GAME_BY_ID: state => {
    return state.gameById
  },
  GAME_NAME: state => {
    return state.gameName
  },
}

const mutations = {
  [GAME_REQUEST]: (state, payload) => {
    state.games = payload
  },
  [GAME_BY_ID]: (state, payload) => {
    state.gameById = payload
  },
  [GAME_NAME]: (state, payload) => {
    state.gameName = payload
  },
}

const actions = {
  [GAME_REQUEST]: ({ commit }) => {
    axios
      .get(GAMES_API)
      .then(response => {
        if (response) {
          const data = response.data
          const games = data.data
          // Thêm game_acive vào các element của games
          if (games) {
            games.forEach(element => {
              element.game_active = false
            })
            const gameName = games.map(v => v.name)
            commit('GAME_NAME', gameName)
            commit(GAME_REQUEST, games)
          }
        }
      })
      .catch(err => {
        console.log('err games: ', err)
      })
  },
  [GAME_BY_ID]: ({ commit }) => {
    commit('loading_game', true)
    if (!localStorage.getItem('game_id')) {
      axios.get(GAMES_API).then(response => {
        const dataGame = response.data.data
        const gameFilter = dataGame.filter(
          item => item.alias === router.currentRoute.params.id
        )
        gameFilter.forEach(element => {
          localStorage.setItem('game_id', element.id)
          axios.get(GAME_ID_API.replace('{game_id}', element.id)).then(res => {
            const data = res.data.data
            commit('GAME_BY_ID', data)
            commit('loading_game', false)
          })
        })
      })
    } else {
      axios
        .get(GAME_ID_API.replace('{game_id}', localStorage.getItem('game_id')))
        .then(res => {
          const data = res.data.data
          localStorage.setItem('message_url', data.messenger_url)
          localStorage.setItem('can_use_code', data.can_use_code)
          commit('GAME_BY_ID', data)
          commit('loading_game', false)
        })
    }
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
